import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.coffeeBrown,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 24
  const h = 25
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)" fillRule="evenodd" clipRule="evenodd" fill={color}>
        <path d="M17.781 6.266a.75.75 0 0 1 0 1.062l-10.5 10.5a.751.751 0 0 1-1.062-1.062l10.5-10.5a.75.75 0 0 1 1.062 0Z" />
        <path d="M6.22 6.266a.75.75 0 0 0 0 1.062l10.5 10.5a.75.75 0 0 0 1.061-1.062l-10.5-10.5a.75.75 0 0 0-1.062 0Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(0 .047)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgComponent
